import React from 'react';

function Testimonials({ resumeData }) {
  if (!resumeData) {
    return null;
  }

  const { testimonials } = resumeData;
  
  if (!testimonials || testimonials.length === 0) {
    return null;
  }

  return (
    <section id="testimonials">
      <div className="text-container">
        <div className="row">
          <div className="two columns header-col">
            <h1><span>Client Testimonials</span></h1>
          </div>
          <div className="ten columns flex-container">
            <div className="flexslider">
              <ul className="slides">
                {testimonials.map((testimonial, index) => (
                  <li key={index}>
                    <blockquote>
                      <p>{testimonial.text}</p>
                      <cite>{testimonial.user}</cite>
                    </blockquote>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Testimonials;